import { render, staticRenderFns } from "./PortalServiciosHeader.vue?vue&type=template&id=a4d2d1b0&scoped=true"
import script from "./PortalServiciosHeader.vue?vue&type=script&lang=ts"
export * from "./PortalServiciosHeader.vue?vue&type=script&lang=ts"
import style0 from "./PortalServiciosHeader.vue?vue&type=style&index=0&id=a4d2d1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d2d1b0",
  null
  
)

export default component.exports